import { render } from "./AddAssinatura.vue?vue&type=template&id=2021aae9"
import script from "./AddAssinatura.vue?vue&type=script&lang=js"
export * from "./AddAssinatura.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__